export default "__VITE_ASSET__CwLPzu06__"